<template>


<div v-if="loaded">
            

  <md-dialog-prompt
      :md-active.sync="coupon_active"
      v-model="coupon"
      md-title="קופון"
      md-input-placeholder="הזן את הקופון שלך"
      @md-confirm="onConfirm()"
      md-confirm-text="שלח" 
      md-cancel-text="בטל"/>
 
  
    <div id="side_primeum" v-if="side">
      <div class="closee" @click="$emit('close')">X</div>
      <h3>מנויי פרימיום <br> נהנים הרבה יותר!</h3>
      <ul>
        <li> <div class="before">V</div>גישה ללא הגבלה לספריית הסדרות והסרטים הנקיים הגדולה בעולם</li>
        <li><div class="before">V</div>גישה חופשית לכל החוגים, הסדנאות והקורסים שלנו</li>
        <li><div class="before">V</div>צפייה חופשית בתכנים המקוריים ובהפקות המקור</li>
        <li><div class="before">V</div>כניסה חופשית להופעות בשידור חי ובהופעות חיות</li>
        <li><div class="before">V</div> ללא תקופת התחייבות - אפשר לבטל תמיד</li>
        <li><div class="before">V</div>יצירת פרופילים אישיים לכל בני מהשפחה</li>
      </ul>
      <h3>49 ש"ח</h3>
      <div class="btn"  @click="showDialog = true ; ">שדרוג מנוי></div>
      <span @click="coupon_active = true">יש לך קופון?</span>
    </div>

    <md-dialog :md-active.sync="showDialog">

      <md-tabs md-dynamic-height>
        <md-tab md-label="תשלום">
          <div id="close_pay" @click="showDialog = false">X</div>
             <iframe style='width:100%; height:450px; border:none;' allowtransparency='true' frameborder='0' scrolling='no' :src="'https://www.tov.tv/payments/do_redirect/' + payment_id"></iframe>

        </md-tab>
      </md-tabs>

    </md-dialog>

</div>

</template>
<style lang="scss">
.md-dialog-container{padding: 50px !important;}
#side_primeum{
  .closee{color: #fff !important;position: absolute;font-size: 22px; top: 30px;right: 30px;cursor: pointer;font-weight: 700;}
  span{    font-size: 18px;color: #9A9A9A;cursor: pointer;}
  .btn{background: #DD1A7B;border-radius: 132.874px;margin: 0 auto;display: block;width: 75%;min-width: 210px;}
  h3{font-size: 35px;font-weight: 700;margin-bottom: 20px;}
  &{text-align: center; z-index: 999;;    position: fixed;top: 0;height: 100vh;left: 0;box-shadow: 0px 0px 13px 1px #ffbb6b;background-color: #000;padding: 30px 0px;width: 25%;min-width: 480px;}
  ul{
    &{margin-bottom: 30px;}
    .before{    background: #DD1A7B;width: 35px;height: 35px;border-radius: 100%;text-align: center;color: #fff;line-height: 37px;font-size: 19px;position: absolute;right: 15px;top: 8px}
    li{border-bottom: 1px solid #4c4c4c;padding-bottom: 0;font-size: 21px;color: #adadad;font-weight: 600;text-align: right;padding-right: 60px;padding-left: 20px;position: relative;min-height: 60px;
    padding-bottom: 10px;line-height: initial;}
  }
}
@media only screen and (max-width: 600px) {
  #side_primeum{min-width: 0 !important;width: 90% !important;}
  #side_primeum ul li{font-size: 15px;min-height:45px}
  #side_primeum ul .before{width: 25px;height: 25px;line-height: 24px;font-size: 17px;}
  .md-tabs.md-theme-default .md-tabs-navigation{display: none;}
  .md-dialog{z-index: 99999 !important;}
  .md-dialog-content{padding: 0 !important;}
  .md-dialog-fullscreen{padding: 0 !important;}
  #close_pay{position: absolute;top: 10px;right: 10px;color: #000;cursor: pointer;font-size: 22px;font-weight: 500;height: 30px;width: 30px;text-align: center;}
}
</style>
<script>
export default {
  data() {
    return {
        payment_id: '',
        loaded: false,
        side: true,
         status: "",
        coupon: "",
       coupon_active: false,
        showDialog: false
    };
  },
  methods:{
     onConfirm(){
      var self = this;
      this.api_call({ url: 'coupon_check', data:{ coupon: this.coupon} ,onComplete: function(data){
        self.status = data.data.data
        if(self.status)
        {
          alert("הקופון התקבל בהצלחה!!")
          window.location.reload();
        }
        else{
          alert("הקופון לא תקין נא נסה שנית")
        }
       
      }})
    },
  },
  created(){
      var self = this;
       this.api_call({ url: 'pay', onComplete: function(data){
           self.payment_id = data.data.data;
           self.loaded = true;
       }
       });
    }
}
</script>